export default "__VITE_ASSET__CRi6We4W__"